/* wcw-wholesale.js */
(function () {
  'use strict';

  // Scroll Reveal
  var els = document.querySelectorAll('.wcw-reveal');
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('wcw-visible'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('wcw-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  // FAQ Accordion
  document.querySelectorAll('.wcw-faq__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = this.getAttribute('aria-expanded') === 'true';
      var id = this.getAttribute('aria-controls');
      var panel = document.getElementById(id);
      document.querySelectorAll('.wcw-faq__q').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.querySelectorAll('.wcw-faq__a').forEach(function (p) { p.classList.remove('wcw-open'); });
      if (!open) {
        this.setAttribute('aria-expanded', 'true');
        panel.classList.add('wcw-open');
      }
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
    });
  });
})();
